import React, {Component} from 'react';
import "./style.less";
export default class PriceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render(){
        return(
            <div className="priceModal" style={this.props.modal ? {display:'block'} : {display:'none'}}>
                <div className="mask"></div>
                <div className="wrap-popup" onClick={this.props.onClose}>
                    <div className="modal" onClick={(e)=>{e.stopPropagation()}}>
                        <div className="content">
                            <div className="title"><span>———————— </span> 票价 <span> ————————</span></div>
                            <div className="price">普通成人票 <span></span>  {this.props.priceInfo.totalPrice ? '￥'+ this.props.priceInfo.totalPrice +'元' : '￥'+ 0 +'元'}</div>
                            <div className="price">
                                抵扣积分 
                                <span></span> 
                                <span className="deduction">{this.props.priceInfo.integral ? '-￥'+ this.props.priceInfo.integral +'元' : '￥'+ 0 +'元'}</span> 
                            </div>
                            <div className="price">
                                抵扣优惠券金额 
                                <span></span> 
                                <span className="deduction">{this.props.priceInfo.discount ? '-￥'+ this.props.priceInfo.discount +'元' : '￥'+ 0 +'元'}</span>
                            </div>
                            <div className="price">普通儿童票 <span></span>  {this.props.priceInfo.babyPrice ? '￥'+ this.props.priceInfo.babyPrice +'元' : '￥'+ 0 +'元'}</div>
                            <div className="price">保险 <span></span> {this.props.priceInfo.baoxian ? '￥'+ this.props.priceInfo.baoxian +'元' : '￥'+ 0 +'元'}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PriceModal/index.js